import type React from 'react';
import { css } from '@compiled/react';
import { LoggedInUser, SharedFooter } from '@atlassian/learning-components';
import { MOBILE, TABLET } from '../../utils/constants';

interface Props {
  isLoggedIn: boolean;
  loggedInUser: LoggedInUser;
}

const CALIFORNIA_PRIVACY_CHOICES_TEXT = 'Your California Privacy Choices';
const CALIFORNIA_PRIVACY_POLICY_URL = 'https://www.atlassian.com/legal/privacy-policy';

const typedGlobalThis = globalThis as typeof globalThis & {
  __OTGEO_US_CA__?: boolean;
};

type SharedFooterWithPolicyLinkProps = React.ComponentProps<typeof SharedFooter> & {
  policyLinkText?: string;
  policyLinkHref?: string;
};

const SharedFooterWithPolicyLink = SharedFooter as React.FC<SharedFooterWithPolicyLinkProps>;

const isUsCaOtgeoOverrideActive = () => {
  if (typeof window === 'undefined') {
    return typedGlobalThis.__OTGEO_US_CA__ === true;
  }

  return new URLSearchParams(window.location.search).get('otgeo')?.toLowerCase() === 'us,ca';
};

const getPolicyLinkProps = () => {
  if (!isUsCaOtgeoOverrideActive()) {
    return {};
  }

  return {
    policyLinkText: CALIFORNIA_PRIVACY_CHOICES_TEXT,
    policyLinkHref: CALIFORNIA_PRIVACY_POLICY_URL,
  };
};

export const Footer = (props: Props) => (
  <>
    <div css={footerSpacerStyles} />
    <SharedFooterWithPolicyLink
      isLoggedIn={props.isLoggedIn}
      email={props.loggedInUser.email}
      {...getPolicyLinkProps()}
    />
  </>
);

const footerSpacerStyles = css({
  height: '112px',
  [TABLET.MEDIA_QUERY]: {
    height: '72px',
  },
  [MOBILE.MEDIA_QUERY]: {
    height: '64px',
  },
});
